import React, { Component } from 'react'
import {
	getViewableLocations,
	getViewableLocation,
} from '../../../../../helpers/trip-search.helper'
import { LightSelectSearchBar } from '../../../../../components/form-components'
import { selectStyles } from './select.style'
export class SelectSearchBar extends Component {
	constructor(props) {
		super(props)
	}

	onChange = (newLocation) => {
		const { options, onChange } = this.props
		const rawLocation = options.find((location) => {
			return (
				newLocation.city === location.city &&
				newLocation.value === location.ibgeCode &&
				newLocation.id === location.id
			)
		})
		onChange(rawLocation)
	}

	render() {
		const {
			options,
			defaultInputValue,
			value,
			placeholder,
			maxMenuHeight,
			onInputChange,
		} = this.props
		return (
			<LightSelectSearchBar
				value={getViewableLocation(value)}
				defaultInputValue={defaultInputValue}
				onChange={this.onChange}
				options={getViewableLocations(options)}
				placeholder={placeholder}
				maxMenuHeight={maxMenuHeight}
				onInputChange={onInputChange}
				styles={selectStyles}
			/>
		)
	}
}
